import { render, staticRenderFns } from "./LeadsStorage.vue?vue&type=template&id=607047d1&scoped=true"
import script from "./LeadsStorage.vue?vue&type=script&lang=js"
export * from "./LeadsStorage.vue?vue&type=script&lang=js"
import style0 from "./LeadsStorage.vue?vue&type=style&index=0&id=607047d1&prod&lang=css"
import style1 from "./LeadsStorage.vue?vue&type=style&index=1&id=607047d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607047d1",
  null
  
)

export default component.exports